import { swalError, swalSuccess } from "../../../helpers/swal";
import * as requestFromServer from "./jobDescriptionRequest";
import { callTypes, jobDescriptionSlice } from "./jobDescriptionSlice";
// import { v4 as uuidv4 } from "uuid";

const { actions } = jobDescriptionSlice;

export const getAllJobDescription = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getJobDescriptionList()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.allJobDescriptionFetched({
            totalCount: data.totalItems,
            entities: data.hrms_job_description,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllJobDescriptionByFilter = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getJobDescriptionListByFilter(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.allJobDescriptionFetched({
            totalCount: data.totalItems,
            entities: data.hrms_job_description,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllCertifications = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getCertificationList()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        // console.log(data);
        const certifications = data.hrms_certification?.map((item) => {
          return {
            label: item?.hrms_certification__name,
            value: item?.hrms_certification__name,
          };
        });
        dispatch(
          actions.jobDescriptionCertifications({
            certifications,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllSkills = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getSkillList()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        const skills = data.hrms_skill?.map((item) => {
          return {
            label: item?.hrms_skill__name,
            value: item?.hrms_skill__name,
          };
        });
        dispatch(
          actions.jobDescriptionSkills({
            skills,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllEmployeeCategory = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEmployeeCategoryList()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        const employeeCategory = data.hrms_employee_categories?.map((item) => {
          return {
            label: item?.hrms_employee_categories__name,
            value: item?.hrms_employee_categories__id,
          };
        });
        dispatch(
          actions.employeeCategoryFetch({
            employeeCategory,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getOneJobDescription = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.jobDescriptionFetched({
        jobDescriptionForEdit: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getOneJobDescription(id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.jobDescriptionFetched({
            jobDescriptionForEdit: data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getGeneralDutyBasedOnDesignation = (id, setFieldValue = false) => (
  dispatch
) => {
  if (!id) {
    return dispatch(
      actions.fetchGeneralDuty({
        generalDuty: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getGeneralDutiesBasedOnDesignation(id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.fetchGeneralDuty({
            generalDuty: data,
          })
        );
        if (setFieldValue) {
          setFieldValue(
            "working_hours",
            `${data?.start_time} - ${data?.end_time}`
          );
        }
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getQuestionsByJobDescription = (id, type_id) => (dispatch) => {
  if (!id && !type_id) {
    return dispatch(
      actions.jobDescriptionQuestions({
        questions: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getQuestionsByJobDescription(id, type_id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        // console.log({ data });
        const ques = data?.hrms_jd_question?.map((item) => {
          return {
            id: item?.hrms_jd_question__id,
            question: item?.hrms_jd_question__question,
            mark: item?.hrms_jd_question__mark,
            is_hybrid: item?.hrms_jd_question__is_hybrid,
          };
        });
        dispatch(
          actions.jobDescriptionQuestions({
            questions: ques,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getQuestionsForApplicant = (id, jd_id, type_id) => (dispatch) => {
  if (!id && !jd_id) {
    return dispatch(
      actions.jobDescriptionMarks({
        marks: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getQuestionsMarkByApplicant(id, jd_id, type_id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.jobDescriptionMarks({
            marks: data?.hrms_applicant_assessment,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAssessmentQuestionsByJobDescription = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.jobDescriptionAssessmentsQuestions({
        assessmentsQuestions: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAssessmentQuestionsByJobDescription(id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        // console.log({ data });
        const ques = data?.hrms_jd_assesment_question?.rows?.map((item) => {
          return {
            id: item?.id,
            question: item?.question,
            marks: item?.marks,
            image: item?.image,
            list: item?.hrms_jd_assesment_question_answer,
          };
        });
        // console.log({ ques });
        dispatch(
          actions.jobDescriptionAssessmentsQuestions({
            assessmentsQuestions: ques,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getJobDescriptionDropdown = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllJobDescriptionList()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        console.log({ data });
        const dropdown = data.hrms_job_description?.map((item) => {
          return {
            value: item.hrms_job_description__id,
            label: item?.hrms_job_description__jd_code
              ? item.hrms_job_description__job_title +
                " (" +
                item?.hrms_job_description__jd_code +
                ")"
              : item.hrms_job_description__job_title,
          };
        });
        dispatch(
          actions.jobDescriptionDropdown({
            dropdown: dropdown,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getJobListDropdown = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllList(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        const jobListDropdown = data.hrms_job?.map((item) => {
          return {
            value: item.hrms_job__id,
            label: item.hrms_job__job_title,
          };
        });
        dispatch(
          actions.jobListDropdown({
            jobListDropdown: jobListDropdown,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getJobDescriptionQuestionTypeDropdown = (requisition_id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getJobDescriptionQuestionTypeList(requisition_id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        // console.log(data);

        const questionType = data.hrms_question_type?.map((item) => {
          return {
            value: item.hrms_question_type__id,
            label: item.hrms_question_type__name,
            slug: item.hrms_question_type__slug,
          };
        });
        dispatch(
          actions.jobDescriptionQuestionType({
            questionType: questionType,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getQuestionTypeDropdownByJob = (job_id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getQuestionTypeListByJob(job_id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;

        const questionType = data?.map((item) => {
          return {
            value: item.interview_type_id,
            label: item.interview_type_name,
            slug: item.interview_type_slug,
          };
        });
        dispatch(
          actions.questionTypeByJob({
            questionTypeByJob: questionType,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

// function removeEmptyChildrenAndAddKeys(data, prefix = "") {
//   return data.map((item, index) => {
//     const uniqueKey = `${prefix}${item.value}-${index}`;
//     const newItem = {
//       ...item,
//       key: uuidv4(),
//     };

//     if (item.children.length > 0) {
//       newItem.children = removeEmptyChildrenAndAddKeys(
//         item.children,
//         `${uuidv4()}-`
//       );
//     } else {
//       delete newItem.children;
//     }

//     return newItem;
//   });
// }

export const getAreaOfInvolvement = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAreaOfInvolvement()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        // dispatch(
        //   actions.areaOfInvolvement({
        //     areaOfInvolvement: data?.children,
        //   })
        // );
        const area = data?.map((item) => {
          return {
            value: item.cost_center_id,
            label: item.cost_center_name,
          };
        });
        dispatch(
          actions.areaOfInvolvement({
            areaOfInvolvement: area,
            areaOfInvolvementList: data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAreaOfInvolvementLabel = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.areaOfInvolvementLabel({
        areaOfInvolvementLabel: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAreaOfInvolvementLabel(id)
    .then((response) => {
      if (response.data.success) {
        const { message } = response.data;
        dispatch(
          actions.areaOfInvolvementLabel({
            areaOfInvolvementLabel: message,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
